class Partner {
	id = null;
	email = '';
	username = '';
	first_name = '';
	last_name = '';
	password = '';
	active = true;
	language_id = null;
	other_languages = [];
	password_change = false;

	constructor(data) {
		for (const [key, value] of Object.entries(data)) {
			this[key] = value;
		}
	}
}

export default Partner;
